"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.patch = exports.post = void 0;
const validation_1 = __importDefault(require("../../../../validation"));
const rules_1 = __importDefault(require("../../../../validation/rules"));
const postBodyRules = {
    email: rules_1.default.string().email().required().label('Email'),
    'g-recaptcha-response': rules_1.default.string(),
};
const postBody = {
    rules: postBodyRules,
    schema: validation_1.default.schema(postBodyRules),
};
const patchBodyRules = {
    email: rules_1.default.string().email().required().label('Email'),
    password: rules_1.default.string().password().required().label('Password'),
    confirmPassword: rules_1.default.string().password().required().oneOf([rules_1.default.ref('password')], 'Passwords must match')
        .label('Confirm Password'),
};
const patchBody = {
    rules: patchBodyRules,
    schema: validation_1.default.schema(patchBodyRules),
};
const patchQueryRules = { token: rules_1.default.string().required() };
const patchQuery = {
    rules: patchQueryRules,
    schema: validation_1.default.schema(patchQueryRules),
};
// eslint-disable-next-line import/prefer-default-export
exports.post = { body: postBody };
exports.patch = {
    body: patchBody,
    query: patchQuery,
};
